<template>
  <section class="SustainabilityBannerCmp">
    <div class="wrapper">
      <div
        v-if="dataBgImage"
        class="bg-image"
        :style="{
          backgroundImage: `url(${dataBgImage})`,
        }"
      />
      <div v-if="lgAndDown" class="seal-wrapper">
        <slot name="seal" />
      </div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 offset-lg-2 col-lg-8">
            <slot />
          </div>
          <div v-if="xlAndUp" class="col-2">
            <div class="seal-wrapper">
              <slot name="seal" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { lgAndDown, xlAndUp } from '@/helpers/breakpoints.js';

export default {
  name: 'SustainabilityBannerCmp',
  props: {
    dataBgImage: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { lgAndDown, xlAndUp };
  },
};
</script>

<style lang="scss" scoped>
.SustainabilityBannerCmp {
  .wrapper {
    position: relative;
    padding: 32px 0;
    background-color: $color-light-bronze;

    @include media-breakpoint-up(xl) {
      max-width: 1280px;
      margin: 0 auto;
      padding: 46px 0;
    }

    .bg-image {
      position: absolute;
      inset: 0;
      background-repeat: no-repeat;
      background-size: auto 367px;
      background-position: left bottom;
      opacity: 0.3;

      @include media-breakpoint-up(md) {
        background-size: auto 414px;
      }

      @include media-breakpoint-up(xl) {
        background-size: auto 367px;
        opacity: 1;
      }
    }

    .seal-wrapper {
      @include media-breakpoint-down(xl) {
        margin-bottom: 32px;
        text-align: center;
      }

      img {
        max-width: 100%;
        height: 115.35px;
        aspect-ratio: 137.97/115.35;
      }
    }
  }

  ::v-deep .title-wrapper {
    @include override-responsive-typography-properties(
      $font-secondary,
      n-heading-3,
      --title-text-title-wrapper
    );
    --title-text-title-wrapper-color: #{$color-bronze};
    --title-text-title-wrapper-padding: 0;

    @include media-breakpoint-up(md) {
      --title-text-title-wrapper-padding: 0 17%;
    }

    @include media-breakpoint-up(lg) {
      @include override-responsive-typography-properties(
        $font-secondary,
        n-heading-2,
        --title-text-title-wrapper
      );
      --title-text-title-wrapper-padding: 0 6.33333333%;
    }

    @include media-breakpoint-up(xl) {
      --title-text-title-wrapper-padding: 0 12.66666667%;
    }
  }
}
</style>
